import whyUsJson from './content/why-us.json';

export const whyUsMock = {
    layoutType: 2,
    data: {
        name: 'why-us',
        areasList: [
            {
                id: 1,
                name: 'WhyUsPage',
                componentName: 'Comp:WhyUsPage',
                content: JSON.stringify(whyUsJson)
            }
        ]
    }
};
